import React, { useEffect, useState } from "react";
import {
  Box,
  MenuItem,
  TextField,
  FormControl,
  InputLabel,
  Select,
} from "@mui/material";
import { Building, MapPin, Phone, Save, User } from "lucide-react";
import whatsAppIcon from "../../utils/whatsapp.svg";

const titles = ["Mr.", "Ms.", "Dr.", "Engr.", "Prof.", "Capt.", "None"];

const UnifiedCustomerForm = ({
  mode = "register",
  customer = {},
  onSave,
  onCancel,
  areaCodes = [],
  loading = false,
}) => {

  const DEPARTMENT_NO =
    localStorage.getItem("currentSelectedDepartment") || "MAIN";
  const API_PATHS = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : "-";
  const BASE_URL = API_PATHS[0].API_CONFIG || "https://cubixweberp.com:213";

  const [isDuplicate, setIsDuplicate] = useState(false);
  const [formData, setFormData] = useState({
    primaryPhone: "",
    primaryCountryCode: "+971",
    altCountryCode: "+971",
    alternatePhone: "",
    whatsappPrimary: false,
    whatsappAlternate: false,
    title: "",
    contactName: "",
    nickname: "",
    email: "",
    comment: "",
    patronType: "Patron",
    areaCode: "",
    creditExpiry: "",
    creditLimit: "",
    trn: "",
    invoice: false,
    city: "",
    country: "United Arab Emirates",
    territory: "Dubai",
    location: "",
    streetAddress: "",
    ...customer,
  });

  const COMPANY_CODE = localStorage?.getItem("companyCode") || "-";
  const CURRENT_USER_OBJECT = localStorage.getItem("currentUser")
    ? JSON.parse(localStorage.getItem("currentUser"))
    : "";
  const CURRENT_USER = CURRENT_USER_OBJECT[0];

  const [errors, setErrors] = useState({});
  const isSupplier = formData.custtype === "s";
  const [countriesList, setCountriesList] = useState([]);

  // Set default area code when areaCodes are available
  useEffect(() => {
    if (areaCodes && areaCodes.length > 0 && !formData.areaCode) {
      setFormData((prev) => ({
        ...prev,
        areaCode: areaCodes[0].ACODE_KEY,
      }));
    }
  }, [areaCodes]);

  const validateForm = () => {
    const newErrors = {};

    if (!formData.contactName.trim()) {
      newErrors.contactName = "Contact name is required";
    }

    // if (!formData.primaryPhone.trim()) {
    //   newErrors.primaryPhone = "Primary phone number is required";
    // }

    if (formData.email && !/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Please enter a valid email address";
    }

    if (formData.creditLimit && parseFloat(formData.creditLimit) < 0) {
      newErrors.creditLimit = "Credit limit cannot be negative";
    }

    if (formData.creditExpiry && parseInt(formData.creditExpiry) < 0) {
      newErrors.creditExpiry = "Due days cannot be negative";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (isDuplicate){
      alert("Customer with same name exist")
      return;
    }  // blocked

    if (validateForm()) {
      const csDes =
        formData.title === "None"
          ? formData.contactName.trim()
          : `${formData.title} ${formData.contactName}`.trim();

      const mappedData = {
        cmpcode: COMPANY_CODE,
        mod: mode === "register" ? "I" : "M",
        cscode:
          mode === "register" ? "00000000" : customer?.ACCOUNT || "00000000",
        ac_code: "0000",
        type: "W",
        cs_des: csDes,
        balance_open: 0,
        dr: 0.0,
        cr: 0.0,
        fc: "AED",
        fdr: 0.0,
        fcr: 0.0,
        divcode: "-",
        keywords: "-",
        adr1: formData.city || "-",
        adr2: formData.streetAddress || "-",
        adr3: formData.territory || "-",
        adr4: formData.contactName || "-",
        adr5: "-",
        tel: `${formData.primaryCountryCode} ${formData.primaryPhone}` || "-",
        fax: "-",
        mobile: `${formData.altCountryCode} ${formData.alternatePhone}` || "",
        salesman: CURRENT_USER?.sales_man || "John Doe",
        areacode: formData.areaCode,
        email: formData.email || "-",
        remarks: formData.comment || "-",
        country: formData.country || "united arab emirates",
        state: "-",
        crlimit: parseFloat(formData.creditLimit) || 0.0,
        duedays: parseInt(formData.creditExpiry) || 30,
        terms: "-",
        crmethod: "Credit Block",
        cntrlcode: "-",
        avtive: "Y",
        colourcode: "-",
        price_cat: "-",
        grade: "A",
        vatregno: formData.trn || "-",
        shippingadr: "-",
        create_user: "admin",
        discount: 0,
        margin: 0,
        GPSCorditate: formData.location || "-",
        PriWhatsapp: formData.whatsappPrimary ? "True" : "False",
        OtWhatsapp: formData.whatsappAlternate ? "True" : "False",
        QtnStat: "-",
        InvStat: "-",
        RetnStat: "-",
        UserTrn: "-",
        UseForDel: "-",
        custtype: isSupplier ? "s" : "c",
        autoid: mode === "edit" ? customer?.AutoId : 1,
        patron: "-",
        patrontype: formData.patronType || "Individual",
        officenumber: "-",
        regno: "-",
        dumpfield: "-",
      };
      onSave([mappedData]);
    }
  };

  const updateFormData = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };
  useEffect(() => {
    fetch("https://cdn.jsdelivr.net/npm/world-countries/countries.json")
      .then((res) => res.json())
      .then((data) => {
        const formatted = data
          .map((country) => {
            const root = country.idd?.root || "";
            const suffix = country.idd?.suffixes?.[0] || "";

            return {
              code: country.cca2.toLowerCase(),
              label: country.name.common,
              value: country.name.common,
              flag: `https://flagcdn.com/w40/${country.cca2.toLowerCase()}.png`,
              phoneCode: root + suffix, // "+91"
            };
          })
          .filter((c) => c.phoneCode) // remove weird edge cases
          .sort((a, b) => a.label.localeCompare(b.label));

        setCountriesList(formatted);
      });
  }, []);

  useEffect(() => {
    if (!formData.contactName.trim()) {
      setIsDuplicate(false);
      return;
    }
  
    const timer = setTimeout(() => {
      const csDes =
        formData.title === "None" || !formData.title
          ? formData.contactName.trim()
          : `${formData.title} ${formData.contactName}`.trim();
  
      fetch(`${BASE_URL}/api/CRMAccountList/${COMPANY_CODE}/WALKINLIST/${DEPARTMENT_NO}/ALL/-/${formData.contactName}`)
        .then((res) => res.json())
        .then((customers) => {
          const found = customers.some(
            (c) => c.DESCRIPTION.trim().toLowerCase() === csDes.trim().toLowerCase()
          );
          setIsDuplicate(found);
        })
        .catch(() => setIsDuplicate(false));
    }, 500); // waits 500ms after user stops typing
  
    return () => clearTimeout(timer);
  }, [formData.contactName, formData.title]);

  const isRegisterMode = mode === "register";
  const headerTitle = isRegisterMode
    ? customer?.id
      ? "Edit Customer"
      : "Add New Customer"
    : `Edit Customer: ${customer?.DESCRIPTION || customer?.contactName || ""}`;

  const buttonText = isRegisterMode ? "Save Customer" : "Save Changes";

  return (
    <div className="bg-white rounded-lg">
      <div className="bg-blue-500 px-6 py-4 rounded-t-lg mb-3">
        <div className="flex items-center justify-between">
          <h2 className="lg:text-xl font-semibold text-white">
            {headerTitle}
            {isRegisterMode && (
              <span className=" lg:inline hidden font-figtree text-gray-100 ms-2 font-medium border px-1 rounded text-sm border-b-2">
                esc
              </span>
            )}
          </h2>
          <div className="flex gap-3">
            <button
              type="button"
              onClick={onCancel}
              className="lg:px-4 px-2 lg:py-2 py-1 bg-gray-600 font-medium text-sm text-white rounded-lg hover:bg-gray-700 transition-colors"
            >
              Cancel
            </button>
            <button
              type="submit"
              onClick={handleSubmit}
              disabled={loading}
              className="lg:px-4 px-2 lg:py-2 py-1 bg-white text-blue-600 text-sm font-medium rounded-lg hover:bg-gray-50 hover:text-blue-700 transition-colors flex items-center"
            >
              {!isRegisterMode && <Save className="w-4 h-4 mr-2" />}
              {loading ? "Saving..." : buttonText}
            </button>
          </div>
        </div>
      </div>

      <div className="px-6 py-4 mb-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {/* Left Column */}
          <div className="space-y-4">
            {/* Title Selection - Only show in register mode */}
            {isRegisterMode && (
              <div className="flex flex-wrap gap-2">
                {titles?.map((title) => (
                  <label
                    key={title}
                    className={`flex items-center gap-1 px-3 py-1 border rounded-lg cursor-pointer text-sm ${
                      formData.title === title
                        ? "border-blue-500 bg-blue-50"
                        : "border-gray-300 hover:border-gray-400"
                    }`}
                  >
                    <input
                      type="radio"
                      name="title"
                      value={title}
                      checked={formData.title === title}
                      onChange={(e) => updateFormData("title", e.target.value)}
                      className="w-3 h-3 text-blue-600"
                    />
                    {title}
                  </label>
                ))}
              </div>
            )}

            {/* Personal Information Section */}
            {!isRegisterMode && (
              <div>
                <h3 className="text-sm font-medium text-gray-900 flex items-center mb-3">
                  <User className="w-4 h-4 mr-2" />
                  Personal Information
                </h3>
              </div>
            )}

            <TextField
              label="Enter Full name"
              value={formData.contactName}
              onChange={(e) => updateFormData("contactName", e.target.value)}
              placeholder="Enter Full name"
              fullWidth
              variant={isRegisterMode ? "standard" : "outlined"}
              size="small"
              error={!!errors.contactName}
              helperText={errors.contactName}
              required
            />

{isDuplicate && (
  <p className="text-xs text-red-500 mt-1">
    A customer with this name already exists.
  </p>
)}

            <div className="grid grid-cols-2 items-center gap-4 w-full">
              <TextField
                label="Enter Email Address"
                value={formData.email}
                onChange={(e) => updateFormData("email", e.target.value)}
                placeholder="Enter Email Address"
                fullWidth
                variant={isRegisterMode ? "standard" : "outlined"}
                size="small"
                error={!!errors.email}
                helperText={errors.email}
              />

              {isRegisterMode ? (
                <TextField
                  select
                  fullWidth
                  variant="standard"
                  label="Patron Type"
                  value={formData.patronType}
                  onChange={(e) => updateFormData("patronType", e.target.value)}
                  size="small"
                  InputLabelProps={{ shrink: true }}
                >
                  <MenuItem value="Patron">Patron</MenuItem>
                  <MenuItem value="vehicle Owner">Vehicle Owner</MenuItem>
                  <MenuItem value="Fleet manager">Fleet Manager</MenuItem>
                  <MenuItem value="None of the above">
                    None of the above
                  </MenuItem>
                </TextField>
              ) : (
                <FormControl size="small" fullWidth>
                  <InputLabel>Patron Type</InputLabel>
                  <Select
                    value={formData.patronType}
                    onChange={(e) =>
                      updateFormData("patronType", e.target.value)
                    }
                    label="Patron Type"
                  >
                    <MenuItem value="Individual">Individual</MenuItem>
                    <MenuItem value="Corporate">Corporate</MenuItem>
                    <MenuItem value="Patron">Patron</MenuItem>
                    <MenuItem value="vehicle Owner">Vehicle Owner</MenuItem>
                  </Select>
                </FormControl>
              )}
            </div>

            {/* Business Information */}
            <div className="grid grid-cols-2 items-center gap-4 w-full">
              <div className="grid grid-cols-2 items-center gap-2">
                <TextField
                  label="Credit Limit"
                  value={formData.creditLimit}
                  onChange={(e) =>
                    updateFormData("creditLimit", e.target.value)
                  }
                  placeholder="Credit Limit"
                  type="number"
                  fullWidth
                  variant={isRegisterMode ? "standard" : "outlined"}
                  size="small"
                  error={!!errors.creditLimit}
                  helperText={errors.creditLimit}
                />

                <TextField
                  label="Credit Expiry (Days)"
                  value={formData.creditExpiry}
                  onChange={(e) =>
                    updateFormData("creditExpiry", e.target.value)
                  }
                  placeholder="Credit Expiry (Days)"
                  type="number"
                  fullWidth
                  variant={isRegisterMode ? "standard" : "outlined"}
                  size="small"
                  error={!!errors.creditExpiry}
                  helperText={errors.creditExpiry}
                />
              </div>

              <div className="grid grid-cols-1 items-center gap-2">
                <TextField
                  fullWidth
                  variant={isRegisterMode ? "standard" : "outlined"}
                  label="Area Code"
                  value={formData.areaCode}
                  onChange={(e) => updateFormData("areaCode", e.target.value)}
                  size="small"
                  InputLabelProps={{ shrink: true }}
                  placeholder="Enter area code"
                />
              </div>
            </div>

            {/* Address Information */}
            {!isRegisterMode && (
              <div>
                <h3 className="text-sm font-medium text-gray-900 flex items-center mb-3">
                  <MapPin className="w-4 h-4 mr-2" />
                  Address Information
                </h3>
              </div>
            )}

            <div className="grid grid-cols-2 items-center gap-4 w-full">
              <TextField
                label="City"
                value={formData.city}
                onChange={(e) => updateFormData("city", e.target.value)}
                placeholder="City"
                fullWidth
                variant={isRegisterMode ? "standard" : "outlined"}
                size="small"
              />

              <TextField
                label="Location"
                value={formData.location}
                onChange={(e) => updateFormData("location", e.target.value)}
                placeholder="Location"
                fullWidth
                variant={isRegisterMode ? "standard" : "outlined"}
                size="small"
              />
            </div>

            <div className="grid grid-cols-2 items-center gap-4 w-full">
              <TextField
                select
                fullWidth
                label="Country"
                value={formData.country}
                onChange={(e) => {
                  const selected = countriesList.find(
                    (c) => c.code === e.target.value,
                  );

                  updateFormData("country", selected.code);
                  updateFormData("primaryCountryCode", selected.phoneCode);
                  updateFormData("altCountryCode", selected.phoneCode);
                }}
                size="small"
              >
                {countriesList.map((country) => (
                  <MenuItem key={country.code} value={country.code}>
                    <img
                      src={country.flag}
                      alt={country.label}
                      width="20"
                      className="mr-2 inline-block align-middle"
                    />
                    {country.label}
                  </MenuItem>
                ))}
              </TextField>

              <TextField
                fullWidth
                variant={isRegisterMode ? "standard" : "outlined"}
                label="Territory"
                value={formData.territory}
                onChange={(e) => updateFormData("territory", e.target.value)}
                size="small"
                InputLabelProps={{ shrink: true }}
                placeholder="Enter territory"
              />
            </div>

            <TextField
              label="Street Address"
              value={formData.streetAddress}
              onChange={(e) => updateFormData("streetAddress", e.target.value)}
              placeholder="Street Address"
              fullWidth
              variant={isRegisterMode ? "standard" : "outlined"}
              size="small"
            />
          </div>

          {/* Right Column - Contact Information */}
          <div className="space-y-4">
            {!isRegisterMode && (
              <div>
                <h3 className="text-sm font-medium text-gray-900 flex items-center mb-3">
                  <Phone className="w-4 h-4 mr-2" />
                  Contact Information
                </h3>
              </div>
            )}

            {/* Primary Phone */}
            <div>
              <div className="flex items-center justify-between mb-2">
                <label className="block text-sm font-medium text-gray-700">
                  Primary Phone
                </label>
                <label className="flex items-center gap-1 text-sm text-gray-600">
                  <input
                    type="checkbox"
                    checked={formData.whatsappPrimary}
                    onChange={(e) =>
                      updateFormData("whatsappPrimary", e.target.checked)
                    }
                    className="w-4 h-4 text-green-600 border-gray-300 rounded-lg"
                  />
                  <img
                    src={whatsAppIcon}
                    alt="whatsapp Icon"
                    className="w-7 h-7"
                  />
                </label>
              </div>

              {isRegisterMode ? (
                <div className="flex gap-2">
                  <TextField
                    select
                    value={formData.primaryCountryCode}
                    onChange={(e) =>
                      updateFormData("primaryCountryCode", e.target.value)
                    }
                    variant="standard"
                  >
                    {countriesList?.map((option) => (
                      <MenuItem key={option.code} value={option.phoneCode}>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <img
                            src={option.flag}
                            alt={option.label}
                            width="20"
                            height="15"
                            style={{ marginRight: 8 }}
                          />
                          {option.phoneCode}
                        </Box>
                      </MenuItem>
                    ))}
                  </TextField>
                  <TextField
                    label="Enter Primary Phone"
                    value={formData.primaryPhone}
                    onChange={(e) =>
                      updateFormData("primaryPhone", e.target.value)
                    }
                    placeholder="Enter Primary Phone"
                    fullWidth
                    variant="outlined"
                    size="small"
                    className="flex-1"
                    error={!!errors.primaryPhone}
                    helperText={errors.primaryPhone}
                  />
                </div>
              ) : (
                <div className="grid grid-cols-3 gap-2">
                  <FormControl size="small">
                    <InputLabel>Code</InputLabel>
                    <Select
                      value={formData.primaryCountryCode}
                      onChange={(e) =>
                        updateFormData("primaryCountryCode", e.target.value)
                      }
                      label="Code"
                    >
                      {countriesList?.map((option) => (
                        <MenuItem key={option.code} value={option.phoneCode}>
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <img
                              src={option.flag}
                              alt={option.label}
                              width="20"
                              height="15"
                              style={{ marginRight: 8 }}
                            />
                            {option.phoneCode}
                          </Box>
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <div className="col-span-2">
                    <TextField
                      size="small"
                      fullWidth
                      label="Primary Phone*"
                      type="tel"
                      value={formData.primaryPhone}
                      onChange={(e) =>
                        updateFormData("primaryPhone", e.target.value)
                      }
                      variant="outlined"
                      error={!!errors.primaryPhone}
                      helperText={errors.primaryPhone}
                    />
                  </div>
                </div>
              )}
            </div>

            {/* Alternate Phone */}
            <div>
              <div className="flex items-center justify-between mb-2">
                <label className="block text-sm font-medium text-gray-700">
                  Alternate Phone
                </label>
                <label className="flex items-center gap-1 text-sm text-gray-600">
                  <input
                    type="checkbox"
                    checked={formData.whatsappAlternate}
                    onChange={(e) =>
                      updateFormData("whatsappAlternate", e.target.checked)
                    }
                    className="w-4 h-4 text-green-600 border-gray-300 rounded-lg"
                  />
                  <img
                    src={whatsAppIcon}
                    alt="whatsapp Icon"
                    className="w-7 h-7"
                  />
                </label>
              </div>

              {isRegisterMode ? (
                <div className="flex gap-2">
                  <TextField
                    select
                    value={formData.altCountryCode}
                    onChange={(e) =>
                      updateFormData("altCountryCode", e.target.value)
                    }
                    variant="standard"
                  >
                    {countriesList?.map((option) => (
                      <MenuItem key={option.code} value={option.phoneCode}>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                          <img
                            src={option.flag}
                            alt={option.label}
                            width="20"
                            height="15"
                            style={{ marginRight: 8 }}
                          />
                          {option.phoneCode}
                        </Box>
                      </MenuItem>
                    ))}
                  </TextField>
                  <TextField
                    label="Enter Alternate Phone"
                    value={formData.alternatePhone}
                    onChange={(e) =>
                      updateFormData("alternatePhone", e.target.value)
                    }
                    placeholder="Enter Alternate Phone"
                    fullWidth
                    variant="outlined"
                    size="small"
                    className="flex-1"
                  />
                </div>
              ) : (
                <div className="grid grid-cols-3 gap-2">
                  <FormControl size="small">
                    <InputLabel>Code</InputLabel>
                    <Select
                      value={formData.altCountryCode}
                      onChange={(e) =>
                        updateFormData("altCountryCode", e.target.value)
                      }
                      label="Code"
                    >
                      {countriesList?.map((option) => (
                        <MenuItem key={option.code} value={option.code}>
                          <Box sx={{ display: "flex", alignItems: "center" }}>
                            <img
                              src={option.flag}
                              alt={option.label}
                              width="20"
                              height="15"
                              style={{ marginRight: 8 }}
                            />
                            {option.label}
                          </Box>
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <div className="col-span-2">
                    <TextField
                      size="small"
                      fullWidth
                      label="Alternate Phone"
                      type="tel"
                      value={formData.alternatePhone}
                      onChange={(e) =>
                        updateFormData("alternatePhone", e.target.value)
                      }
                      variant="outlined"
                    />
                  </div>
                </div>
              )}
            </div>

            {/* TRN and Business Info for Edit Mode */}
            {!isRegisterMode && (
              <div>
                <h3 className="text-sm font-medium text-gray-900 flex items-center mb-3">
                  <Building className="w-4 h-4 mr-2" />
                  Business Information
                </h3>
              </div>
            )}

            <TextField
              label="TRN Number"
              value={formData.trn}
              onChange={(e) => updateFormData("trn", e.target.value)}
              placeholder="TRN Number"
              fullWidth
              variant={isRegisterMode ? "standard" : "outlined"}
              size="small"
            />

            <TextField
              label="Flash Comment"
              value={formData.comment}
              onChange={(e) => updateFormData("comment", e.target.value)}
              fullWidth
              variant={isRegisterMode ? "standard" : "outlined"}
              placeholder="Flash Comment"
              size="small"
              multiline
              rows={isRegisterMode ? 3 : 2}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnifiedCustomerForm;
